import React, { Component } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link } from 'react-router-dom'
import ErrorBG from './error_bg.svg'

export default class Warning extends Component {
    constructor(props) {
        super(props)

        this.state = {
            warningIndex: 0,
        }

        this.translation = JSON.parse(localStorage.translation)[
            localStorage.language
        ]
    }

    render() {
        let { subscribeData, subscribeInfo, additionalData } = this.props
        let { fail_url } = subscribeData
        let {
            action_id,
            complete_success,
            complete_investor_address,
        } = subscribeInfo
        let errorBox = this.structureOfError(this.props.additionalData.desc)
        return (
            <div className="upshot-wrap">
                <div className="upshot-wrap__circle upshot-wrap__circle_error upshot-wrap__circle_first" />
                <div className="upshot-wrap__circle upshot-wrap__circle_error upshot-wrap__circle_second" />
                <div className="upshot-wrap__circle upshot-wrap__circle_error upshot-wrap__circle_third" />
                <div className="upshot">
                    <div
                        style={{ backgroundImage: `url(${ErrorBG})` }}
                        className="upshot__header"
                    >
                        <p className="upshot__title">Error</p>
                        <p>Something went wrong...</p>
                    </div>
                    <div className="upshot__content">
                        {this.checkErrorType(errorBox) ? (
                            <div className="upshot__count">
                                <p>{`${this.state.warningIndex + 1} of ${
                                    errorBox.length
                                }`}</p>
                            </div>
                        ) : null}
                        <div className="upshot__box-wrap">
                            {this.checkErrorType(errorBox) ? (
                                <React.Fragment>
                                    {this.state.warningIndex > 0 ? (
                                        <FontAwesomeIcon
                                            className="angle-left"
                                            icon={'angle-left'}
                                            onClick={() => {
                                                this.changeWarningIndex(
                                                    'minus',
                                                    errorBox.length - 1
                                                )
                                            }}
                                        />
                                    ) : null}
                                    {this.state.warningIndex !==
                                    errorBox.length - 1 ? (
                                        <FontAwesomeIcon
                                            className="angle-right"
                                            icon={'angle-right'}
                                            onClick={() => {
                                                this.changeWarningIndex(
                                                    'plus',
                                                    errorBox.length - 1
                                                )
                                            }}
                                        />
                                    ) : null}
                                </React.Fragment>
                            ) : null}
                            {Array.isArray(errorBox)
                                ? errorBox[this.state.warningIndex]
                                : errorBox}
                        </div>
                        <a
                            href={`${fail_url}action_id=${action_id}&complete_success=${
                                complete_success ? 1 : 0
                            }&investor_address=${complete_investor_address}`}
                        >
                            <button className="upshot__button">Continue</button>
                        </a>
                    </div>
                </div>
            </div>
        )
    }

    changeWarningIndex = (action, limit) => {
        let { warningIndex } = this.state
        if (action === 'plus' && warningIndex === limit) return null

        if (action === 'plus') {
            this.setState({
                warningIndex: this.state.warningIndex + 1,
            })
        } else if (action === 'minus') {
            this.setState({
                warningIndex: this.state.warningIndex - 1,
            })
        } else {
            return null
        }
    }

    checkErrorType = error => {
        if (Array.isArray(error) && error.length > 0) {
            return true
        } else {
            return false
        }
    }

    structureOfError = desc => {
        if (Array.isArray(desc) && desc.length > 1) {
            let listOfError = desc.map((item, i) => {
                return (
                    <div className="upshot__box" key={i}>
                        <p>{this.correctAnswer(item)}</p>
                        <p />
                    </div>
                )
            })
            return listOfError
        } else {
            return (
                <div className="upshot__box">
                    <p>
                        {this.correctAnswer(
                            Array.isArray(desc) ? desc[0] : desc
                        )}
                    </p>
                    <p />
                </div>
            )
        }
    }

    correctAnswer = str => {
        return (
            str.replace(/[^a-z]/gi, ' ')[0].toUpperCase() +
            str.replace(/[^a-z]/gi, ' ').slice(1)
        )
    }
}
